module.exports = __webpack_public_path__ + "static/img/zhuye.ad61276.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/zhuye.jpg
// module id = tUoF
// module chunks = 1